import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { FixedAssetService } from 'app/shared/services/fixed-asset.service';
import { AuthService } from 'app/shared/services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { NbThemeService } from '@nebular/theme';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import * as moment from 'moment';


@Component({
  selector: 'ngx-fixed-asset',
  templateUrl: './fixed-asset.component.html',
  styleUrls: ['./fixed-asset.component.scss']
})
export class FixedAssetComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();

  isDark: boolean = false;
  itemForm: FormGroup;
  warehouseList: any[];
  isItemCodeReadOnly : boolean= true;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  isShowAttachBtn: boolean=false;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  category =[
    {value: 'Buildings'},
    {value: 'Land'},
    {value: 'Machinery and Equipment'},
    {value: 'Furniture and Fixtures'}, 
    {value: 'Computer Systems and Software'},
    {value: 'Vehicles'},
  
  ];


  location =[
    {value : 'ROOM-101'},
    {value : 'ROOM-102'},
    {value : 'ROOM-103'},
    {value : 'ROOM-104'},
    {value : 'ROOM-105'},
    {value : 'ROOM-106'},
    {value : 'ROOM-201'},
    {value : 'ROOM-202'},
    {value : 'ROOM-203'},
    {value : 'ROOM-204'},
    {value : 'ROOM-205'},
    {value : 'ROOM-206'},
    {value : 'ROOM-ARALIYA'},
    {value : 'ROOM-KING'},
    {value : 'ROOM-NELUM'},
    {value : 'ROOM-OLU'},
    {value : 'OFFICE'},
    {value : 'KITCHEN'},
    {value : 'SWIMMING POOL'},
    {value : 'STORE'},

    {value : 'RECEPTION'},
    {value : 'BAR'},
    {value : 'KAYAK HOLDER'},
    {value : 'BOAT ITEM'},
    {value : 'UNDER THE WATER TANK'},
    {value : 'ROOF TOP SOLA'},
    {value : 'ENGINE ITEM'},
    {value : 'BEHIND THE BAR'},
    {value : 'OVER THE WATER TANK'},
    {value : 'GENERATOR'},
    {value : 'BIKE ITEM'},
    {value : 'GAS STORE'},
    {value : 'CHEMICAL STORE'},
    {value : 'STAFF ROOM 1'},
    {value : 'STAFF ROOM 2'},
    {value : 'WATER PUMP'},
    {value : 'CHAIRS PLASTIC'},
    {value : 'CHAIRS WOODEN'},
    {value : 'CUTLERY'},
    {value : 'LINEN'},
    {value : 'PLATE'},
    {value : 'GLASS'},
  

  ];

  WARRANTY_TYPE = [
    {value : 'Standard Warranty'},
    {value : `Manufacturer's Warranty`},
    {value : 'Parts Warranty'},
    {value : 'Service Warranty'},
    {value : 'Limited Warranty'},
    {value : 'Lifetime Warranty'}
  ]


  validationMessages = {
    'assetCode' : { 'required': 'This field is required' },
    'assetName' : { 'required': 'This field is required' },
    'category' : { 'required': 'This field is required' },
    'location' : { 'required': 'This field is required' },
    'qty' : { 'required': 'This field is required' },

  };

  formErrors = {
    'assetCode' : "",
    'assetName' : "",
    'category' : "",
    'location' : "",
    'qty' : "",

  };



  constructor(private fb: FormBuilder,
              private fixedAssetService: FixedAssetService,
              private authService: AuthService,
              private toastr: ToastrService,
              private dialogService: DialogService,
              private themeService: NbThemeService,
              private router : Router, 
              private fileUploadService:FileUploadService,
             ) { 
                this.datepickerConfig = Object.assign({},
                  {   
                    showWeekNumbers:false,
                    dateInputFormat : 'YYYY-MM-DD'
                  });
             }

  ngOnInit() {
    this.initFormFields();
    this.getDataTableRowData();
    this.getControlPermissions();
 
   this.itemForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.itemForm);
  });

  this.themeService.onThemeChange()
  .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });
 

  } // end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='FA'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  attachFileButtonClick(){
    this.fileUploadService.refNo = this.itemForm.value.assetCode;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }

  initFormFields() : void{
    this.itemForm = this.fb.group({
      id : [null],
      assetCode: ['',Validators.required],
      assetName: ['',Validators.required],
      serialNo: [''],
      category: [null,Validators.required],
      location: [null,Validators.required],
      purchaseDate: [''],
      cost: [''],
      qty: ['',Validators.required],
      usefulLife: [''],
      usefulQty: [''],
      disposalQty: [''],
      vendorName: [''],
      vendorAddress: [''],
      warrantyType: [null],
      warrantyPeriod: [''],
      warrantyExpiredOn: [''],
      warrantyConditions: [''],
      remarks: [''],

    });
  }

  newButtonClick(): void {
    this.itemForm.reset();
    this.enableForm();
    this.isItemCodeReadOnly = false;
    this.getMaxId();
    this.isShowAttachBtn = false;
   }

   getMaxId(){
    var id = 0;
    var sId : String;
  
    this.fixedAssetService.getMaxId()
    .subscribe(
      (res) => {
                  id = Number(res[0].MaxId) + 1;
                  sId = id.toString().padStart(6,'0');
                  this.itemForm.patchValue({
                    assetCode : "FA" + sId
                  });
                  

                },        
      (err) =>  {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }, 
      )



   }


  saveButtonClick(): void {
    
    this.logValidationErrors(this.itemForm,true);
    const data= this.mapFormValuesToModel()
          if(this.isFilledFromFields()){
            
              if(!this.itemForm.value.id){
                this.showProcessingIndicator = true;
                this.fixedAssetService.addFixedAsset(data)
                .subscribe(
                  (res) => {
                              console.log(res);
                             if(res.success === 0){
                                this.toastr.error('This asset id already exist.', 'warning');
                                this.showProcessingIndicator = false;
                             }else if(res.success === 1){
                                this.toastr.success('Fixed asset added successfully','Success');                          
                                this.showProcessingIndicator = false; 
                                this.newButtonClick();
                              }
                            },        
                  (err) =>  {
                              this.toastr.error('Failed to add record','Failure');                                                         
                              this.showProcessingIndicator = false;
                              if(err instanceof HttpErrorResponse){                 
                                if(err.status == 401){
                                  this.router.navigate(['/login']);
                                }
                              }
                              console.log(err);
                            }, 
                  )
  
                    

            }else{
            this.dialogService.openConfirmDialog('Are you sure you want to update this record?')
            .afterClosed().subscribe(res =>{
              if(res){
              this.showProcessingIndicator = true;
              this.fixedAssetService.updateFixedAsset(data)
            .subscribe(
              (res) => {
                          this.toastr.success('Updated successfully','Success');     
                          this.showProcessingIndicator = false;  
                          this.newButtonClick();
                        },        
              (err) =>  {
                          this.toastr.error('Failed to update record','Failure');
                          this.showProcessingIndicator = false;
                          if(err instanceof HttpErrorResponse){                 
                            if(err.status == 401){
                              this.router.navigate(['/login']);
                            }
                          }
                          console.log(err);
                        }, 
                      )

          }else{
            this.showProcessingIndicator = false;
          }
            })

        }

      }
      else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;
        
      } 
                       
         
   }



   enableForm():void{
    Object.keys(this.itemForm.controls).forEach(key => {
      this.itemForm.controls[key].enable();
      
    });

  }


  disableForm():void{
    Object.keys(this.itemForm.controls).forEach(key => {
      this.itemForm.controls[key].disable();   
    });

  }
  
  logValidationErrors(group: FormGroup = this.itemForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.itemForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }


  isFilledFromFields() : boolean {
    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
        return true;
  }

  


  mapFormValuesToModel(){  
    
    const formData = {
      ...this.itemForm.value,
      purchaseDate:this.itemForm.value.purchaseDate ? moment(this.itemForm.value.purchaseDate).format("YYYY-MM-DD"): null,
      warrantyExpiredOn:this.itemForm.value.warrantyExpiredOn ? moment(this.itemForm.value.warrantyExpiredOn).format("YYYY-MM-DD"): null,
      createdBy:this.authService.getUserLoggedIn()
    }

    return formData;
  }


activeStatus = false;
viewItem(data:any){
  this.itemForm.patchValue({  
    id      :data.Id,
    assetCode:data.AssetCode,
    assetName:data.AssetName,
    serialNo:data.SerialNo,
    category:data.Category,
    location:data.Location,
    purchaseDate:data.PurchaseDate ? moment(data.PurchaseDate).format("YYYY-MM-DD"):null,
    cost:data.Cost,
    qty:data.Qty,
    usefulLife:data.UsefulLife,
    usefulQty:data.UsefulQty,
    disposalQty:data.DisposalQty,
    vendorName:data.VendorName,
    vendorAddress:data.VendorAddress,
    warrantyType:data.WarrantyType,
    warrantyPeriod:data.WarrantyPeriod,
    warrantyExpiredOn:data.WarrantyExpiredOn ? moment(data.WarrantyExpiredOn).format("YYYY-MM-DD"):null,
    warrantyConditions:data.WarrantyConditions,
    remarks:data.Remarks,
    
  })

  this.isShowAttachBtn = true;

}

getDataTableRowData(){
  var data = this.fixedAssetService.dataRow;
  if(data){
    this.viewItem(data);
  }
  else{
    this.newButtonClick();
  }

}


}
